export const important = "RQd";
export const hasAttachments = "SQd";
export const meeting = "TQd";
export const meetingAccepted = "UQd";
export const meetingDeclined = "VQd";
export const meetingTentative = "WQd";
export const meetingCanceled = "XQd";
export default {important,hasAttachments,meeting,meetingAccepted,meetingDeclined,meetingTentative,meetingCanceled};